import React, { useEffect, useState } from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../App.css';
import '../style.css';
import { rlsBypassQuery } from '../api/rlsBypassQuery';

function TopSellingModels() {
  const [combined, setCombined] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedRow, setExpandedRow] = useState(null);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      try {
        // calculate the last month
        const now = new Date();
        const startOfThisMonth = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1));
        const startOfLastMonth = new Date(Date.UTC(startOfThisMonth.getUTCFullYear(), startOfThisMonth.getUTCMonth() - 1, 1));
        const endOfLastMonth = new Date(startOfThisMonth.getTime() - 1);

        // Step 1: Fetch all customer mr_ids
        const customers = await rlsBypassQuery({
          table: 'modelreports',
          select: 'mr_id, created_at',
          filters: [
            { column: 'created_at', operator: 'gte', value: startOfLastMonth.toISOString() },
            { column: 'created_at', operator: 'lte', value: endOfLastMonth.toISOString() },
          ],
          limit: 1000,
        });

        // Step 2: Count how many times each mr_id appears
        const countMap = {};
        customers.forEach(({ mr_id }) => {
          const key = String(mr_id);
          countMap[key] = (countMap[key] || 0) + 1;
        });

        // Step 3: Fetch model data
        const models = await rlsBypassQuery({
          table: 'customer_model_reports',
          select: 'id, model, make, drivetrain, mr_approval, chassis_code, sevs_entry',
          limit: 1000,
        });

        // Step 4: Merge and calculate total sold per model
        const combinedData = models.map((model) => {
          const id = String(model.id);
          const sold = countMap[id] || 0;
          return {
            ...model,
            totalSold: sold,
          };
        });

        // Sort and keep top 5
        const top5 = combinedData
          .filter((m) => m.totalSold > 0)
          .sort((a, b) => b.totalSold - a.totalSold)
          .slice(0, 5);

        setCombined(top5);
      } catch (error) {
        console.error("❌ Error fetching top-selling data:", error.message || error);
        setCombined([]);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);
// setting month name for the title
const date = new Date();
date.setMonth(date.getMonth() - 1);
const monthName = date.toLocaleString('default', { month: 'long' }); 
const year = date.getFullYear();
const images = [
  '/image/1.JPG',
  '/image/2.JPG',
  '/image/3.jpg',
  '/image/4.JPG',
  '/image/5.JPG',
  '/image/6.jpg',
  '/image/7.JPG',
  '/image/8.JPG',
  '/image/9.jpg',
  '/image/3.jpg',
  '/image/10.jpg',
  '/image/11.jpg',
  '/image/12.jpg',
  '/image/13.jpg',
  '/image/14.jpg',
  '/image/15.jpg',
  '/image/16.jpg',
  '/image/17.jpg',
  '/image/18.jpg',
  '/image/19.jpg',
  '/image/20.jpg',

];
//const monthName = new Date().toLocaleString('default', { month: 'long' });
const heading = `Top Selling Model Reports for ${monthName}  ${year}`;
  return (
    <div className="container-fluid shadow -lg p-5 mb-5" >
      <h1 className="mb-4 text-center heading-title fw-bold">{heading}</h1>

      {loading ? (
        <p>Loading...</p>
      ) : combined.length > 0 ? (
        <div className="row">
          <div className="col-12 col-md-4 mb-3 d-none d-lg-block .equal-height">
            {/*code to add multiple photo like slideshow */}

         <div id="customCarousel" className="carousel slide" data-bs-ride="carousel">
      <div className="border border-2 border-dark carousel-inner" >
        {images.map((imgSrc, index) => (
          <div
            className={`carousel-item ${index === 0 ? 'active' : ''}`}
            key={index}
          >
            <div className="image-container">
              <img src={imgSrc} className="d-block w-100 " alt={`Slide ${index + 1}`} />
            </div>
          </div>
        ))}
      </div>

      {/* Optional controls */}
      <button className="carousel-control-prev" type="button" data-bs-target="#customCarousel" data-bs-slide="prev">
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button className="carousel-control-next" type="button" data-bs-target="#customCarousel" data-bs-slide="next">
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>





          </div>

          <div className="col-12 col-lg-8 mb-3 ">
            <div className="table-responsive " style={{ borderTop: "1px solid #101110ff", paddingTop: "12px" }}>
              <table className="table table-hover transparent-table align-middle image-container">
                <thead>
                  <tr>
                    <th>S/N</th>
                    <th>Make</th>
                    <th>Model Name</th>
                    <th>Chassis Code</th>
                    <th>Servs Entry</th>
                    <th>MRE Approval</th>
                    
                  </tr>
                </thead>
                <tbody>
                  {combined.map((m, index) => (
                    <React.Fragment key={m.id}>
                      <tr
                        onClick={() => setExpandedRow(expandedRow === m.id ? null : m.id)}
                        style={{ cursor: 'pointer' }}
                      >
                        <td data-label="Slno">{index + 1}</td>
                        <td data-label="Make">{m.make}</td>
                        <td data-label="Model"><i className="bi bi-car-front-fill me-2 text-secondary"></i>{m.model}</td>
                        <td data-label="Chassis code">{m.chassis_code}</td>
                        <td data-label="Sevs Entry">{m.sevs_entry}</td>
                        <td data-label="MRE Approval">{m.mr_approval}</td>
                        
                      </tr>
                      
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ) : (
        <p>No sales data available.</p>
      )}
    </div>
  );
}

export default TopSellingModels;
